// extracted by mini-css-extract-plugin
module.exports = {"sportsMenuToggleButton":"_28497a6","open":"_7ec1591"};